export type KakaoLoginRuntime = {
  hasDocument: boolean;
  hasFetch: boolean;
  hasWindow: boolean;
  isAndroid: boolean;
  isKakaoTalkInAppBrowser: boolean;
  isMetaInAppBrowser: boolean;
  isMobileWeb: boolean;
  sdkCapable: boolean;
  userAgent: string;
};

type DetectKakaoLoginRuntimeParams = {
  hasDocument?: boolean;
  hasFetch?: boolean;
  hasWindow?: boolean;
  userAgent?: string;
};

const MOBILE_USER_AGENT_PATTERN = /android|iphone|ipad|ipod|mobile/i;
const ANDROID_USER_AGENT_PATTERN = /android/i;
const KAKAOTALK_IN_APP_BROWSER_PATTERN = /kakaotalk/i;
const META_IN_APP_BROWSER_PATTERN = /instagram|fban|fbav|fb_iab|fbios/i;

export function detectKakaoLoginRuntime(
  params: DetectKakaoLoginRuntimeParams = {},
): KakaoLoginRuntime {
  const hasWindow = params.hasWindow ?? typeof window !== "undefined";
  const hasDocument = params.hasDocument ?? typeof document !== "undefined";
  const hasFetch = params.hasFetch ?? typeof fetch === "function";
  const userAgent = params.userAgent ?? (
    hasWindow && typeof window.navigator?.userAgent === "string"
      ? window.navigator.userAgent
      : ""
  );
  const isAndroid = ANDROID_USER_AGENT_PATTERN.test(userAgent);
  const isKakaoTalkInAppBrowser = KAKAOTALK_IN_APP_BROWSER_PATTERN.test(userAgent);
  const isMetaInAppBrowser = META_IN_APP_BROWSER_PATTERN.test(userAgent);
  const isMobileWeb = MOBILE_USER_AGENT_PATTERN.test(userAgent);

  return {
    hasDocument,
    hasFetch,
    hasWindow,
    isAndroid,
    isKakaoTalkInAppBrowser,
    isMetaInAppBrowser,
    isMobileWeb,
    sdkCapable: hasWindow && hasDocument && hasFetch,
    userAgent,
  };
}

export function shouldUseKakaoSdkLogin(runtime: KakaoLoginRuntime) {
  return runtime.isMobileWeb && runtime.sdkCapable;
}

export function shouldRecommendExternalBrowserForKakao(runtime: KakaoLoginRuntime) {
  return runtime.isAndroid && (runtime.isMetaInAppBrowser || runtime.isKakaoTalkInAppBrowser);
}
